/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Nextup_TitleInputs */

const en_nextup_title = /** @type {(inputs: Nextup_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Next up`)
};

const de_nextup_title = /** @type {(inputs: Nextup_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Als Nächstes`)
};

/**
* | output |
* | --- |
* | "Next up" |
*
* @param {Nextup_TitleInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const nextup_title = /** @type {((inputs?: Nextup_TitleInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Nextup_TitleInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_nextup_title(inputs)
	return en_nextup_title(inputs)
});